import React from 'react';
import { TextField } from '@material-ui/core';
import DateTimePicker from './DateTimePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DateField = ({ label, value = null, onChange, style, format = 'DD/MM/YYYY', ...props }) => {
  return (
    <DateTimePicker
      value={value}
      format={format}
      onChange={onChange}
      {...props}
      TextFieldComponent={(props) => {
        return (
          <div style={{ position: 'relative' }}>
            <TextField
              fullWidth
              label={label}
              placeholder="DD/MM/YYYY"
              InputLabelProps={{ shrink: true }}
              variant="standard"
              style={style}
              error={false}
              helperText={false}
              {...props}
            />
            <FontAwesomeIcon
              {...props}
              icon="calendar-alt"
              size="sm"
              color={props.disabled ? '#00000061' : 'inherit'}
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                top: props.helperText ? '26%' : '65%',
                right: 10,
              }}
            />
          </div>
        );
      }}
    />
  );
};

export default DateField;
